module.exports = __webpack_public_path__ + "static/CalibreWeb-Black-86a5fdab6f1dcfd7cdececbfb16adaa9.woff";